// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": () => import("/Users/juanpablodelatorrevaldez/Desktop/curso-react/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/juanpablodelatorrevaldez/Desktop/curso-react/.cache/data.json")

